import styled from "styled-components";
interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}

export const Styles = styled.div<IProps>`
  .ant-select-selector {
    background: ${(props) =>
      props.background ? props.background + " !important" : ""};
    .org-infor {
      color: ${(props) => (props.color ? props.color + " !important" : "")};
    }
  }

  &.has-deleted-value {
    .ant-select-selection-item {
      color: #bfbfbf !important;
    }
  }

  .org-infor.deleted-selection,
  .deleted-option-text {
    color: #bfbfbf !important;
  }
`;
